import { Children, useEffect, useState } from "react";

import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { ModalDeleteCore, TableCore, TdCore } from "src/Pages/components";
import { handleChipCoreCategories } from "src/Pages/components/CategoryComponentMap";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";
import {
  DeleteForeverIcon,
  InfoOutlinedIcon,
  FolderCopyIcon,
  FolderOffIcon,
  ModeEditIcon,
  CheckIcon,
  CloseIcon,
} from "src/Pages/components/Icons/Icons";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { handleFormatDateIfIsNull } from "src/shared/Utils/handleFormatDateIfIsNull";
import { handleIfLimitCharacter } from "src/shared/Utils/LimitText";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { FilterSidebarComissaoProdutor } from "../FilterSidebar/FilterSidebar";
import { ModalChangeIsActive } from "../ModalChangeIsActive/ModalChangeIsActive";
import { ModalViewComissãoCorretora } from "../ModalComissaoProdutor/Index";

import { UseGetByIdComissaoProdutor } from "./Hooks/UseGetByIdComissaoProdutor";
import { useHttpTableComissaoProdutor } from "./Hooks/useHttpTableComissaoProdutor";
import { THeadComissaoProdutor } from "./THead";
import { ModalComissaoProdutor } from "../Form";
import PaidIcon from '@mui/icons-material/Paid';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useLocation } from "react-router-dom";
import { UrlConfig } from "src/shared/Utils/paths";
import { CustomTabs } from "src/Pages/components/CustomTabs/CustomTabs";
import { Chip } from "@mui/material";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { UseDownloadPdfComissaoProdutor } from "../PdfViewComissionProducer/UseDownloadPdfComissaoProdutor";

export const TableComissaoProdutor = () => {
  const { valueAutoCompOperadoraFilter, valueAutoProdutor } = UseAutoCompletedAll();
  const { handleVerifyPermissionItem } = UseVerifyIsPermissionsUser();

  const { handleGetById } = UseGetByIdComissaoProdutor();
  const { handleGet } = useHttpTableComissaoProdutor();
  const { handleDownloadPdf, loading: loadingPdf } = UseDownloadPdfComissaoProdutor();

  const { listComissaoProdutor, valuesFilterComissaoProdutor } =
    useContextComissoes();

  const [openModalComissaoProdutor, setOpenModalComissaoProdutor] = useState(false);

  const {
    setActive_incluir,
    setNameSearch,
    itensPerPage,
    currentPage,
    nameSearch,
    attTable,
    setId,
  } = useConfigPageContext();

  const [openModalComissao, setOpenModalComissao] = useState(false);
  const [openModalChangeIsActive, setOpenModalChangeIsActive] = useState(false);
  const [stateIsActiveComissao, setIsActiveComissao] = useState<
    boolean | undefined
  >();
  const urlProdutor = UrlConfig.comissao.produtor.url;

  const { pathname } = useLocation();

  const [value, setValue] = useState(pathname !== urlProdutor ? "1" : "2");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const tabs = [
    {
      label: "Comissão Corretora",
      value: "1",
      to: UrlConfig.comissao.corretora.url,
    },
    {
      label: "Comissão Produtor",
      value: "2",
      to: UrlConfig.comissao.produtor.url,
    },
  ];

  const [idModalCommission, setIdModalCommission] = useState<string>("");

  const handleGetIdToEdit = (id: string) => {
    setId(id);
    handleGetById(id);
    setOpenModalComissaoProdutor(true);
  };

  useEffect(() => {
    handleGet({
      itensPerPage,
      currentPage,
      nameSearch,
      codeOperadora: valueAutoCompOperadoraFilter.id,
      isActive: valuesFilterComissaoProdutor.isActive,
      name: valuesFilterComissaoProdutor.name,
      produtorCode: valueAutoProdutor.id,
      tipo_produtor: valuesFilterComissaoProdutor.tipo_produtor,
      funcao_produtor: valuesFilterComissaoProdutor.funcao_produtor,
    });
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/comissoes/produtor" });

  return (
    <TableCore
      Modals={
        <>
          <ModalViewComissãoCorretora
            id={idModalCommission}
            open={openModalComissao}
            setId={setIdModalCommission}
            setOpen={setOpenModalComissao}
          />
          <ModalChangeIsActive
            isActive={stateIsActiveComissao}
            modalDelete={openModalChangeIsActive}
            setModalDelete={setOpenModalChangeIsActive}
          />
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
          />
        </>
      }
      THead={<THeadComissaoProdutor />}
      filter={<FilterSidebarComissaoProdutor />}
      qtdList={listComissaoProdutor.length}
      setNameSearch={setNameSearch}
      tab={
        <CustomTabs
          tabs={tabs}
          currentValue={value}
          onChange={handleChange}
        />
      }
      cardAdd={{
        title: "Comissão do Produtor",
        subTitle: "Configure as comissões que você Paga para Corretores, Supervisores e Gerentes.",
        icon: <PaidIcon color="primary" />,
        buttonAdd: [
          <ModalComissaoProdutor
            key={1}
            openModal={openModalComissaoProdutor}
            setOpenModal={setOpenModalComissaoProdutor}
          />,
        ],
      }}
    >
      {Children.toArray(
        listComissaoProdutor.map((item) => {
          return (
            <TableRowCore id={item.code}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        title: "Editar",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.COMMISSIONS_PRODUCER.EDITAR.id
                        ),
                        onClick: () => {
                          setId(item.code);
                          handleGetIdToEdit(item.code);
                          setActive_incluir(true);
                        },
                        icon: <ModeEditIcon fontSize="small" />,
                      },
                      {
                        title: item.is_active
                          ? "Desativar grade"
                          : "Ativar grade",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.COMMISSIONS_PRODUCER.EDITAR.id
                        ),

                        onClick: () => {
                          setId(item.code);
                          setOpenModalChangeIsActive(true);
                          setIsActiveComissao(!item.is_active);
                        },
                        icon: item.is_active ? (
                          <FolderOffIcon fontSize="small" />
                        ) : (
                          <FolderCopyIcon fontSize="small" />
                        ),
                      },
                      {
                        title: "Excluir",
                        background: "error",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.COMMISSIONS_PRODUCER.DELETAR.id
                        ),
                        onClick: () => {
                          setIdModalDelete(item.code);
                          setOpenModalDelete(true);
                        },
                        icon: <DeleteForeverIcon fontSize="small" />,
                      },
                    ]}
                  />
                }
              />
              <TdCore values={<Chip label={`${item.code}`} sx={{ padding: "0 6px" }} />} />
              <TdCore
                values={
                  <>
                    <ButtonCore
                      title="Ver comissão"
                      variant="outlined"
                      size="small"
                      sx={{ mr: 1 }}
                      onClick={() => {
                        setIdModalCommission(item.code);
                        setOpenModalComissao(true);
                      }}
                    />
                    <ButtonCore
                      title={loadingPdf ? "..." : "PDF"}
                      variant="outlined"
                      size="small"
                      color="error"
                      disabled={loadingPdf}
                      startIcon={<PictureAsPdfIcon />}
                      onClick={() => handleDownloadPdf(item.code)}
                    />
                  </>
                }
              />

              <TdCore values={`${item.operadora_code} - ${item.operadora_name}`} />

              <TdCore values={item.administradora_code && `${item.administradora_code} - ${item.administradora_name}`} />

              <TdCore values={`${item.modalidade_code} - ${item.modalidade_name}`} />

              <TdCore
                tooltip={
                  item?.produtor_code
                    ? `${item.produtor_code} - ${item.produtor_nome}`
                    : ""
                }
                values={
                  item?.produtor_code
                    ? handleIfLimitCharacter({
                      LIMIT: 25,
                      value: `${item.produtor_code} - ${item.produtor_nome}`,
                    })
                    : ""
                }
              />
              <TdCore
                textAlign="center"
                values={item.vitalicio &&
                  <Chip variant="outlined" label={("Começa na " + (item.vitalicio || "NONE") + "ª parcela")} />
                }
              />

              <TdCore
                textAlign="left"
                values={
                  item.is_special
                    ? handleChipCoreCategories("COMISSAO_ESPECIAL")
                    : handleChipCoreCategories(item.funcao_produtor)
                }
              />

              <TdCore
                textAlign="left"
                values={
                  item.is_special
                    ? handleChipCoreCategories("COMISSAO_ESPECIAL")
                    : handleChipCoreCategories(item.tipo_produtor)
                }
              />

              <TdCore
                borderBottom={`1px solid #0e6aff`}
                color="#0e6aff"
                textAlign="center"
                values={FormatDateBR(
                  handleFormatDateIfIsNull(item.date_vigencia)
                )}
              />

              <TdCore
                textAlign="center"
                values={
                  item.is_active ? (
                    <CheckIcon color="success" />
                  ) : (
                    <CloseIcon color="error" />
                  )
                }
              />

              <TdCore
                textAlign="center"
                tooltip={`Usuário com id: '${item.id_user_create
                  }' criou na data: ${FormatDateBR(item.created_at)}
                / Usuário com id '${item.id_user_update
                  }' Editou na data: ${FormatDateBR(item.update_at)}`}
                values={<InfoOutlinedIcon />}
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
